import { ListItemButton as _ListItemButton } from "./list-item-button";
import { ListItemButtonText } from "./list-item-button-text";
import { withStaticProperties } from "@fhs/utils";
export type { ListItemButtonProps } from "./list-item-button";

export const ListItemButton = withStaticProperties(_ListItemButton, {
  Text: ListItemButtonText,
});
